import classNames from 'classnames'

import './portal-tag.css'

export interface PortalTagProps {
    label: string
    variant?: 'team' | 'company'
    className?: string
}

/** Small coloured pill used for team / company affiliations in the People list. */
export const PortalTag = ({ label, variant = 'team', className }: PortalTagProps) => (
    <span className={classNames('portal-tag', `portal-tag--${variant}`, className)}>{label}</span>
)
